import AttachFile from "@mui/icons-material/AttachFile";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { prettyPrintDocumentType } from "encamp-shared/src/utils/prettyPrintDocumentType";
import { Document } from "generated-graphql/graphql";
import { useDocumentDownload } from "hooks/useDocumentDownload";
import { useState } from "react";

type DocumentRow = Pick<Document, "id" | "title" | "documentType">;

export const DocumentButton = ({ documents }: { documents: DocumentRow[] }) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!documents.length) return null;

  return (
    <Stack gap={1}>
      <Box>
        <Button
          endIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{ color: theme.palette.text.secondary }}
        >
          {isExpanded ? "hide" : "show"} Documents {`(${documents.length})`}
        </Button>
      </Box>

      {isExpanded && (
        <Box>
          {documents.map((document) => (
            <DocumentRow key={document.id} document={document} />
          ))}
        </Box>
      )}
    </Stack>
  );
};

const DocumentRow = ({
  document: { id, title, documentType },
}: {
  document: DocumentRow;
}) => {
  const theme = useTheme();
  const { fetchAndHandleDownload } = useDocumentDownload();
  return (
    <Tooltip title={`Download ${title}`}>
      <Stack
        direction="row"
        sx={{ color: theme.palette.primary.main, cursor: "pointer" }}
        alignItems="center"
        onClick={() => fetchAndHandleDownload({ documentId: id })}
      >
        <IconButton size="small" sx={{ color: theme.palette.primary.main }}>
          <AttachFile />
        </IconButton>
        <Typography
          variant="caption"
          sx={{
            whiteSpace: "nowrap",
            minWidth: 0,
            flex: 1,
          }}
        >
          <Box
            component="span"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              verticalAlign: "bottom",
              display: "inline-block",
              maxWidth: "100%",
            }}
            title={title}
          >
            {title}
          </Box>
          <Box
            component="span"
            sx={{
              color: theme.palette.text.secondary,
              whiteSpace: "nowrap",
              ml: 0.5,
            }}
          >
            | {prettyPrintDocumentType(documentType)}
          </Box>
        </Typography>
      </Stack>
    </Tooltip>
  );
};
